import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Hidden,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from 'react-alert';
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import tokenDecoder from '../../../utils/tokenDecoder';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CountUp from 'react-countup';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecordAndNew: {
    backgroundColor: '#FFBE00'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

var screenCode = 'INVOICEPAYMENTAPPROVAL';
export default function InvoicePaymentApprovalAddEdit(props) {
  const navigate = useNavigate();
  const alert = useAlert();
  const { referenceNumber } = useParams();
  const { groupID } = useParams();
  const { factoryID } = useParams();
  const [title, setTitle] = useState('Payment');
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const [factories, setFactories] = useState();
  const [suppliers, setSuppliers] = useState();
  const [suppliersAuto, setSuppliersAuto] = useState();
  const [payVoucherCode, setPayVoucherCode] = useState();
  const [groups, setGroups] = useState();
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [tranLedgerList, setTranLedgerList] = useState([]);
  const [tranLedgerListAuto, setTranLedgerListAuto] = useState([]);
  const [refNo, setRefNo] = useState("");
  const [refNoInter, setRefNoInter] = useState();
  const [voucherCode, setVoucherCode] = useState();
  const [voucherCodeRef, setVoucherCodeRef] = useState();
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedDueDate, handleDueDateChange] = useState(new Date().toISOString());
  const [financialYearStartDate, setFinancialYearStartDate] = useState();
  const [dateDisable, setDateDisable] = useState(false);
  const [journalData, setJournalData] = useState([]);
  const [journalDataCreditRecordUpdate, setJournalDataCreditRecordUpdate] = useState({});
  const [accountTypeNames, setAccountTypeNames] = useState();
  const [childHeaderNames, setChildHeaderNames] = useState();
  const [approveButtonEnabled, setApproveButtonEnabled] = useState(false);
  const [transactionModeCode, setTransactionModeCode] = useState();
  const [status, setStatus] = useState(0);
  const [recordAndNewBtnEnable, setRecordAndNewBtnEnable] = useState();
  const [isInterStatus, setIsInterStatus] = useState(false);
  const [supplierCommon, setSupplierCommon] = useState(false);
  const [accountDescriptions, setAccountDescriptions] = useState({});
  const [accountDescriptionsTypeAll, setAccountDescriptionsTypeAll] = useState({});
  const [ledgerAccountTRCode, setledgerAccountTRCode] = useState([]);
  const [ledgerAccountTRCodeFnl, setledgerAccountTRCodeFnl] = useState("");
  const [bankBranchCode, setBankBranchCode] = useState([]);
  const [ChequeNumberError, setChequeNumberError] = useState("");
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveButtonEnabled: false
  });

  const [generalJournal, setGeneralJournal] = useState({
    groupID: '0',
    factoryID: '0',
    transactionTypeID: '0',
    ledgerTransactionID: 0,
    referenceNumber: '',
    description: '',
    descriptionTypeID: 0,
    payModeID: '0',
    chequeNumber: '',
    isActive: true,
    preparedBy: '',
    updatedBy: '',
    voucherType: '0',
    voucherCode: '',
    transactionMode: '0',
    recipientName: '',
    address: '',
    isInterEstate: false,
    interEstateID: '0',
    tranLedgerAccountID: '0',
    supplierID: '0',
    ledgerAccountTRCode: '',
    modeoftransaction: '0',
    modeoftransactionNumber: '',
    payee: '',
    bankCode: '',
    branchCode: '',
    childHeaderID: '0'
  });
  const maxDate = new Date();
  const handleClick = () => {
    navigate('/app/LankemPayment/listing');
  };

  let decrypted = 0;
  let decryptedfactoryID = 0;
  let decryptedgroupID = 0;

  useEffect(() => {
    getPermissions();
    getGroupsForDropdown();
    getPayVoucherCode();
  }, []);

  useEffect(() => {
    if (generalJournal.groupID !== '0') {
      trackPromise(getfactoriesForDropDown());
    }
  }, [generalJournal.groupID]);
  useEffect(() => {
    if (generalJournal.isInterEstate && parseInt(generalJournal.interEstateID) !== 0) {
      trackPromise(getReferenceNumberInter());
    }
  }, [voucherCodeRef, generalJournal.isInterEstate, generalJournal.interEstateID]);

  useEffect(() => {
    if (generalJournal.factoryID !== '0') {
      trackPromise(
        getChildHeaderNames(generalJournal.groupID, generalJournal.factoryID),
        getChildHeaderNames(generalJournal.groupID, generalJournal.factoryID)
      );
      //trackPromise(getTranLedgerList(), 
      trackPromise(getTranLedgerListAuto());
      trackPromise(getLedgerAccountTRCode());
      trackPromise(getVoucherTypeList());
      trackPromise(getTransactionModeList());
      trackPromise(getFinancialYearStartEndDate());
    }
  }, [generalJournal.factoryID]);

  useEffect(() => {
    if (generalJournal.factoryID !== '0') {
      trackPromise(getTranLedgerList());
    }
  }, [generalJournal.factoryID]);

  useEffect(() => {
    decrypted = atob(referenceNumber.toString());
    decryptedgroupID = atob(groupID.toString());
    decryptedfactoryID = atob(factoryID.toString());
    if (decrypted != 0) {
      trackPromise(
        getGeneralJournalDetails(
          decrypted,
          decryptedgroupID,
          decryptedfactoryID
        )
      );
    } else {
      setJournalData([
        {
          accountTypeName: 0,
          credit: 0,
          debit: 0,
          description: undefined,
          descriptionTypeID: 0,
          ledgerTransactionID: 0,
          rowID: GenerateRandomID(),
          childHeaderID: '0',
          childHeaderName: '0'
        }
      ]);
    }
  }, []);

  useEffect(() => {
    if (generalJournal.factoryID.toString() !== '0') {
      trackPromise(getSuppliersForDropDown(), getSuppliersForDropDownAuto());
    }
  }, [generalJournal.factoryID]);

  useEffect(() => {
    if (generalJournal.tranLedgerAccountID.toString() !== '0') {
      var listedone = ledgerAccountTRCode.find(x => x.ledgerAccountID === parseInt(generalJournal.tranLedgerAccountID))
      setledgerAccountTRCodeFnl(listedone === undefined || listedone === null ? "" : listedone.ledgerAccountTRCode)
    }
  }, [generalJournal.tranLedgerAccountID]);

  useEffect(() => {
    if (generalJournal.factoryID) {
      setRefNo("");
    }
  }, [generalJournal.factoryID]);

  useEffect(() => {
    if (payVoucherCode && ledgerAccountTRCodeFnl !== "" && generalJournal.factoryID !== '0' && ledgerAccountTRCodeFnl !== '0') {
      trackPromise(getReferenceNumber());
    }
  }, [ledgerAccountTRCodeFnl]);

  useEffect(() => {
    if (generalJournal.factoryID !== '0') {
      trackPromise(GetBankBranchCode());
    }
  }, [generalJournal.tranLedgerAccountID]);

  useEffect(() => {
    if (generalJournal.modeoftransactionNumber > 0) {
      getChequeNumberAvailable()
    }
  }, [generalJournal.modeoftransactionNumber]);

  useEffect(() => {
    if (!isUpdate) {
      setGeneralJournal({
        ...generalJournal,
        modeoftransactionNumber: ''
      });
      setChequeNumberError("");
    }
  }, [generalJournal.tranLedgerAccountID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'ADDEDITGURUGODALLAPAYMENTINVOICEAPPROVAL'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );
    var isApproveButtonEnabled = permissions.find(
      p => p.permissionCode == 'INVOICEPAYMENTAPPROVALAPPROVEBUTTONENABLED'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveButtonEnabled: isApproveButtonEnabled !== undefined
    });

    setGeneralJournal({
      ...generalJournal,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getReferenceNumber() {
    let refModel = {
      groupID: generalJournal.groupID,
      factoryID: generalJournal.factoryID,
      date: selectedDate.toLocaleString().split('T')[0],
      voucherCode: payVoucherCode.voucherCode,
      ledgerAccountTRCode: ledgerAccountTRCodeFnl
    };
    const ref = await services.getReferenceNumber(refModel);
    setRefNo(ref.data);
  }

  async function getReferenceNumberInter() {
    if (generalJournal.isInterEstate) {
      let refModel = {
        groupID: generalJournal.groupID,
        factoryID: generalJournal.interEstateID,
        date: selectedDate.toLocaleString().split('T')[0],
        voucherCode: voucherCodeRef
      };
      const ref = await services.getReferenceNumber(refModel);
      setRefNoInter(ref.data);
    }
  }

  async function GetBankBranchCode() {
    let BBModel = {
      groupID: parseInt(generalJournal.groupID),
      factoryID: parseInt(generalJournal.factoryID),
      ledgerAccountID: parseInt(generalJournal.tranLedgerAccountID),
    };
    const BBCode = await services.GetBankBranchCode(BBModel);
    setBankBranchCode(BBCode.data);
  }

  async function getChequeNumberAvailable() {
    var response = await services.getChequeNumberAvailable(generalJournal.factoryID, bankBranchCode.bankCode, bankBranchCode.branchCode, generalJournal.modeoftransactionNumber);
    if (response.data.length == 0) {
      setChequeNumberError("");
    }
    else {
      setChequeNumberError("Cheque Number Allready Exist!");
    }
  }

  async function getLedgerAccountTRCode() {
    const trCode = await services.getLedgerAccountTRCode(generalJournal.factoryID);
    setledgerAccountTRCode(trCode);
  }

  async function getTranLedgerList() {
    const transaction = await services.getTranLedgerListForDropdown(generalJournal.factoryID);
    setTranLedgerList(transaction);
  }

  async function getTranLedgerListAuto() {
    const transaction = await services.getTranLedgerListForAutoDropdown(generalJournal.factoryID);
    setTranLedgerListAuto(transaction);
  }

  async function getAccountTypeNames(childHeaderModel) {
    const accounts = await services.getLedgerAccountNamesForDatagrid(childHeaderModel);
    setAccountTypeNames(accounts);
    return accounts;
  }

  async function getChildHeaderNames(groupID, factoryID) {
    const accounts = await services.getChildHeaderNamesForDatagrid(groupID, factoryID);
    setChildHeaderNames(accounts);
    return accounts;
  }

  async function getAccountDescriptionsALL(tranLedgerAccountID) {
    const accountDescriptions = await services.getAccountDescriptionsAll(tranLedgerAccountID);
    setAccountDescriptionsTypeAll(accountDescriptions);
  }

  async function getFinancialYearStartEndDate() {
    const yearDate = await services.getFinancialYearStartDateByGroupIDFactoryID(
      generalJournal.groupID,
      generalJournal.factoryID
    );
    if (yearDate !== null) {
      setFinancialYearStartDate(yearDate.financialYearStartDate);
      setDateDisable(false);
    } else {
      alert.error('Please Config the Financial Year');
      setDateDisable(true);
      setFinancialYearStartDate(new Date());
    }
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(
      generalJournal.groupID
    );
    setFactories(factory);
  }

  async function getSuppliersForDropDown() {
    const supplierResult = await services.getSuppliersForDropDown(
      generalJournal.factoryID
    );
    setSuppliers(supplierResult);
  }

  async function getSuppliersForDropDownAuto() {
    const supplierResult = await services.getSuppliersForDropDownAuto(
      generalJournal.factoryID
    );
    setSuppliersAuto(supplierResult);
  }

  async function getPayVoucherCode() {
    const payVoucherCodes = await services.getPayVoucherCode(
      generalJournal.groupID
    );
    setPayVoucherCode(payVoucherCodes);
  }

  async function getGeneralJournalDetails(referenceNumber, groupID, factoryID) {
    let response = await services.getGeneralJournalDetailsByReferenceNumber(
      referenceNumber,
      groupID,
      factoryID
    );
    let data = response;
    setTitle('Update Payment');
    setIsUpdate(true);
    setGeneralJournal({
      ...generalJournal,
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      ledgerTransactionID: data[0].ledgerTransactionID,
      transactionTypeID: data[0].transactionTypeID,
      referenceNumber: data[0].referenceNumber,
      description: data[0].description,
      descriptionTypeID: data[0].descriptionTypeID,
      recipientName: data[0].recipientName,
      transactionMode: data[0].transactionModeID,
      modeoftransaction: data[0].modeoftransactionID,
      modeoftransactionNumber: data[0].modeoftransactionNumber == null ? data[0].chequeNumber : data[0].modeoftransactionNumber,
      voucherType: data[0].voucherTypeID,
      payModeID: data[0].payModeID,
      chequeNumber: data[0].chequeNumber == null ? '' : data[0].chequeNumber,
      preparedBy: data[0].preparedBy,
      isInterEstate: data[0].isInterEstate,
      interEstateID: data[0].interEstateID,
      supplierID: data[0].supplierID,
      tranLedgerAccountID: data[0].tranLedgerAccountID,
      payee: data[0].payee
    });
    const supplierResult = await services.getSuppliersForDropDownAuto(
      data[0].factoryID
    );

    var foundCustomer = supplierResult.find(x => x.supplierID === data[0].supplierID);
    if (foundCustomer && foundCustomer.supplierCode == "COMMON") {
      setSupplierCommon(true)
    } else {
      setSupplierCommon(false)
    }
    setStatus(data[0].status);
    setRefNo(data[0].referenceNumber);
    setIsInterStatus(data[0].isInterEstate)
    handleDateChange(data[0].date)

    let copyArray = data;
    let tranLedgerAccountID = data[0].tranLedgerAccountID;

    let childHeaderModel = {
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      childHeaderID: data[0].childHeaderID
    }

    let accountNameList = await getAccountTypeNames(childHeaderModel);
    let tempArray = [...journalData]

    var filteredArray = copyArray.filter((x) => x.accountTypeName !== tranLedgerAccountID);
    var filteredCreditArray = copyArray.filter((x) => x.accountTypeName === tranLedgerAccountID);
    findCreditAccountTransactionUpdate(filteredCreditArray[0], accountNameList);
    filteredArray.forEach(element => {
      let reuslt = GetAll(element.accountTypeName, accountNameList);
      getAccountDescriptionsALL(element.accountTypeName)
      tempArray.push(
        {
          accountTypeName: element.accountTypeName,
          description: element.description,
          credit: element.credit,
          debit: element.debit,
          ledgerTransactionID: element.ledgerTransactionID,
          rowID: GenerateRandomID(),
          ledgerAccountCode: element.ledgerAccountCode,
          ledgerAccountName: element.ledgerAccountName,
          descriptionTypeID: element.descriptionTypeID,
          selected: reuslt,
          ledgerAccountName: element.ledgerAccountName,
          childHeaderName: element.childHeaderName,
        }
      )
    });
    setJournalData(tempArray)
  }

  function findCreditAccountTransactionUpdate(filteredCreditArray, accountNameList) {
    let reuslt = GetAll(filteredCreditArray.accountTypeName, accountNameList);
    getAccountDescriptionsALL(filteredCreditArray.accountTypeName);

    let model = {
      accountTypeName: filteredCreditArray.accountTypeName,
      description: filteredCreditArray.description,
      credit: filteredCreditArray.credit,
      debit: filteredCreditArray.debit,
      ledgerTransactionID: filteredCreditArray.ledgerTransactionID,
      rowID: 0,
      ledgerAccountCode: filteredCreditArray.ledgerAccountCode,
      ledgerAccountName: filteredCreditArray.ledgerAccountName,
      descriptionTypeID: filteredCreditArray.descriptionTypeID,
      tranLedgerAccountID: filteredCreditArray.tranLedgerAccountID,
      selected: reuslt
    }
    setJournalDataCreditRecordUpdate(model)
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    setVoucherTypes(voucherTypes);
    decrypted = atob(referenceNumber.toString());
    if (decrypted == 0) {
      voucherTypes.forEach(x => {
        if (x.screenCode == 'PAYMENT') {
          setGeneralJournal({
            ...generalJournal,
            voucherType: parseInt(x.voucherTypeID)
          });
        }
      });
    }
    return voucherTypes;
  }

  async function getTransactionModeList() {
    const transactionModes = await services.getTransactionModeList();
    return transactionModes;
  }

  async function SaveGeneralJournal() {
    let newArray = []
    let index = journalData.findIndex(x => x.accountTypeName === 0);
    if (index >= 0) {
      alert.error('Account name is required, please check');
      if (index > 0) {
        journalData.splice(index, 1);
      }
      return;
    }

    var findZeroRecords = journalData.filter(x => parseFloat(x.debit) == 0)
    if (findZeroRecords.length !== 0) {
      alert.error('Amount Should be more than 0');
      return;
    }

    var sameBankAccount = journalData.filter(x => x.accountTypeName == generalJournal.tranLedgerAccountID)
    if (sameBankAccount.length > 0) {
      alert.error('Same Debit and Credit Accounts Not Allowed');
      return;
    }

    if (!isUpdate) {
      let sumCredit = 0
      journalData.forEach(X => {
        sumCredit += parseFloat(X.debit)
      });
      let credit = {
        accountTypeName: generalJournal.tranLedgerAccountID,
        credit: sumCredit,
        debit: 0,
        description: journalData[0].description,
        descriptionTypeID: journalData[0].descriptionTypeID,
        disableCreditField: false,
        disableDebitField: true,
        ledgerTransactionID: 0,
        rowID: journalData[0].rowID,
      }
      journalData.push(credit)
    } else {
      let sumCredit = 0
      journalData.forEach(X => {
        sumCredit += parseFloat(X.debit)
      });

      let credit = {
        accountTypeName: journalDataCreditRecordUpdate.tranLedgerAccountID,
        credit: sumCredit,
        debit: 0,
        description: journalDataCreditRecordUpdate.description,
        descriptionTypeID: journalDataCreditRecordUpdate.descriptionTypeID,
        disableCreditField: false,
        disableDebitField: true,
        ledgerTransactionID: journalDataCreditRecordUpdate.ledgerTransactionID,
        rowID: journalDataCreditRecordUpdate.rowID,
      }
      journalData.push(credit)
    }

    newArray.push(journalData)
    index = journalData.findIndex(x => x.accountTypeName === 0);
    if (index >= 0) {
      alert.error('Account name is required, please check');
      journalData.splice(index, 1);
      return;
    }
    if (!isUpdate) {
      journalData.forEach(function (part, index) {
        journalData[index].accountTypeName = parseInt(part.accountTypeName);
        journalData[index].debit = parseFloat(part.debit);
        journalData[index].description = part.description;
        journalData[index].descriptionID = part.descriptionTypeID;
      });
      setJournalData(journalData)
    }
    var finalArray = journalData.filter(e => e.accountTypeName !== 0);
    if (!isUpdate) {
      if (ledgerAccountTRCodeFnl == null) {
        journalData.splice(index, 1);
        alert.error("Transaction not permitted for this account.");
        return;
      }
      let saveModel = {
        groupID: generalJournal.groupID,
        factoryID: generalJournal.factoryID,
        transactionTypeID: generalJournal.transactionTypeID,
        referenceNumber: refNo,
        referenceNumberInter: refNoInter,
        chequeNumber: generalJournal.modeoftransaction == 1 ? generalJournal.modeoftransactionNumber : '',
        voucherType: generalJournal.voucherType,
        transactionMode: generalJournal.transactionMode,
        voucherCode: voucherCode,
        recipientName: generalJournal.recipientName,
        isActive: true,
        journalData: finalArray,
        date: selectedDate,
        dueDate: selectedDueDate,
        interEstateID: generalJournal.interEstateID,
        isInterEstate: generalJournal.isInterEstate,
        supplierID: generalJournal.supplierID,
        tranLedgerAccountID: generalJournal.tranLedgerAccountID,
        status: approveButtonEnabled == true ? parseInt(2) : parseInt(1),
        modeoftransaction: generalJournal.modeoftransaction,
        modeoftransactionNumber: generalJournal.modeoftransaction == 2 ? generalJournal.modeoftransactionNumber : '',
        payee: generalJournal.payee,
      };
      if (recordAndNewBtnEnable) {
        let response = await services.saveGeneralJournal(saveModel);

        if (response.statusCode == 'Success') {
          alert.success('Payment saved successfully');
          clearData();
          navigate('/app/LankemPayment/listing');
        } else {
          journalData.splice(index, 1);
          alert.error(response.message);
        }
      } else {
        let response = await services.saveGeneralJournal(saveModel);

        if (response.statusCode == 'Success') {
          alert.success('Payment saved successfully');
          clearData();
          navigate('/app/LankemPayment/listing');
        } else {
          journalData.splice(index, 1);
          alert.error(response.message);
        }
      }
    } else {
      let updateModel = {
        ledgerTransactionID: generalJournal.ledgerTransactionID,
        groupID: generalJournal.groupID,
        factoryID: generalJournal.factoryID,
        transactionTypeID: generalJournal.transactionTypeID,
        tranLedgerAccountID: generalJournal.tranLedgerAccountID,
        referenceNumber: generalJournal.referenceNumber,
        voucherType: generalJournal.voucherType,
        transactionMode: generalJournal.transactionMode,
        recipientName: generalJournal.recipientName,
        chequeNumber: generalJournal.chequeNumber,
        isActive: true,
        journalData: finalArray,
        date: selectedDate,
        dueDate: selectedDueDate,
        voucherCode: generalJournal.voucherCode
      };
      let response = await services.updateGeneralJournal(updateModel);
      if (response.statusCode == 'Success') {
        alert.success('Payment updated successfully');
        clearData();
        navigate('/app/LankemPayment/listing');
      } else {
        journalData.splice(index, 1);
        alert.error(response.message);
      }
    }
  }

  function GetAll(ledgerAccountID, accountTypeNames) {
    const result = accountTypeNames.filter(
      a => a.ledgerAccountID.toString() === ledgerAccountID.toString()
    );
    return result;
  }

  function GetAllChildHeaderNames(childHeaderID, childHeaderNames) {
    const result = childHeaderNames.filter(
      a => a.childHeaderID.toString() === childHeaderID.toString()
    );
    return result;
  }

  function generateDropownForVoucherList(dataList) {
    let items = [];
    if (dataList != null) {
      voucherTypes.forEach(x => {
        if (x.screenCode == 'LANKEMPAYMENT') {
          items.push(
            <MenuItem key={x.voucherTypeID} value={x.voucherTypeID}>
              {x.voucherTypeName}
            </MenuItem>
          );
        }
      });
    }
    return items;
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value;
    setGeneralJournal({
      ...generalJournal,
      [e.target.name]: value
    });
  }

  function handleChangeSupplier(e) {
    const target = e.target;
    const value = target.value;
    setGeneralJournal({
      ...generalJournal,
      [e.target.name]: value
    });
    if ((value > 0) && (suppliers[value].code == 'COMMON')) {
      setSupplierCommon(true);
    } else {
      setSupplierCommon(false);
    }
  }

  function handleSearchDropdownChangeFields(data, e) {
    if (data === undefined || data === null) {
      setGeneralJournal({
        ...generalJournal,
        tranLedgerAccountID: '0'
      });
      return;
    } else {
      var valueV = data["ledgerAccountID"];
      setGeneralJournal({
        ...generalJournal,
        tranLedgerAccountID: valueV
      });
    }
  }

  function handleChangeForChequeNumber(e) {
    const target = e.target;
    let value = target.value;

    if (/^[0-9]*$/.test(value)) {
      setChequeNumberError("");
    }
    else {
      setChequeNumberError("Invalid input. Please enter a valid Cheque number.");
    }
  }

  function handleSearchDropdownChangeFieldsSupplier(data, e) {
    if (data === undefined || data === null) {
      setGeneralJournal({
        ...generalJournal,
        supplierID: '0'
      });
      return;
    } else {
      var valueV = data["supplierID"];
      var valueC = data["supplierCode"];
      setGeneralJournal({
        ...generalJournal,
        supplierID: valueV
      });

      if ((parseInt(valueV) > 0) && (valueC == 'COMMON')) {
        setSupplierCommon(true);
      } else {
        setSupplierCommon(false);
      }
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader onClick={handleClick} />
        </Grid>
      </Grid>
    );
  }

  function calDebitTotal() {
    let sum = 0;
    journalData.forEach(x => {
      sum += parseFloat(x.debit);
      x.debit = parseFloat(x.debit);
      x.ledgerTransactionID = parseFloat(x.ledgerTransactionID);
      x.description = x.description;
      x.descriptionTypeID = x.descriptionTypeID;
    });
    return sum.toFixed(2);
  }

  function findLoginUser() {
    return tokenDecoder.getUserNameFromToken();
  }

  function Cancel() {
    navigate('/app/LankemPayment/listing');
  }

  const RecordAndNew = () => {
    setRecordAndNewBtnEnable(true);
    setApproveButtonEnabled(false);
  };

  const ApproveClick = () => {
    setRecordAndNewBtnEnable(false);
    setApproveButtonEnabled(true);
  };

  function clearData() {
    setGeneralJournal({
      ...generalJournal,
      transactionTypeID: '0',
      referenceNumber: '',
      description: '',
      descriptionTypeID: 0,
      payModeID: '0',
      chequeNumber: '',
      isActive: true,
      preparedBy: '',
      updatedBy: '',
      voucherCode: '',
      transactionMode: '0',
      recipientName: '',
      tranLedgerAccountID: '0',
      supplierID: '0',
      bankCode: '',
      branchCode: '',
      rowID: GenerateRandomID(),
      childHeaderID: 0,
      childHeaderName: '0'
    });
    setJournalData([
      {
        accountTypeName: 0,
        credit: 0,
        debit: 0,
        description: '',
        descriptionTypeID: 0,
        ledgerTransactionID: 0,
        rowID: GenerateRandomID()
      }
    ]);
    handleDateChange(new Date());
    handleDueDateChange(new Date().toISOString());
    setRefNo('');
    setVoucherCode('');
  }

  async function handleSearchDropdownChange(e, data, rowID) {
    if (data === undefined || data === null) return;
    let valueV = data['ledgerAccountID'];
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));

    const descriptions = await services.getAccountDescriptions(valueV);
    const newDesc = { ...accountDescriptions };
    delete newDesc[rowID];
    if (descriptions.length > 0) {
      newDesc[rowID] = descriptions;
    }
    setAccountDescriptions(newDesc);

    let reuslt = GetAll(valueV, accountTypeNames);
    const existingRecords = newArr.filter(record => record.AccountTypeName == valueV);
    if (newArr[idx].accountTypeName !== parseInt(valueV)) {
      newArr[idx] = {
        ...newArr[idx],
        accountTypeName: parseInt(valueV),
        selected: reuslt,
        disableCreditField: existingRecords.length > 0 ? existingRecords[0].disableCreditField : false,
        disableDebitField: existingRecords.length > 0 ? existingRecords[0].disableDebitField : false,
        description: "",
        descriptionTypeID: 0
      };
    } else {
      newArr[idx] = {
        ...newArr[idx],
        accountTypeName: parseInt(valueV),
        selected: reuslt,
        description: "",
        descriptionTypeID: 0
      };
    }
    setJournalData(newArr);
  }

  async function handleSearchDropdownChangeForChildHeaders(e, data, rowID) {
    if (data === undefined || data === null)
      return;
    let valueV = data["childHeaderID"];
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    let childHeaderModel = {
      groupID: generalJournal.groupID,
      factoryID: generalJournal.factoryID,
      childHeaderID: valueV
    }
    const accountNameList = await services.getLedgerAccountNamesForDatagrid(childHeaderModel);
    setAccountTypeNames(accountNameList);
    let result = GetAllChildHeaderNames(valueV, childHeaderNames)
    if (newArr[idx].childHeaderID !== parseInt(valueV)) {
      newArr[idx] = {
        ...newArr[idx],
        childHeaderID: parseInt(valueV),
        selectedChildHeader: result,
      };
    } else {
      newArr[idx] = {
        ...newArr[idx],
        childHeaderID: parseInt(valueV),
        selectedChildHeader: result
      };
    }
    setJournalData(newArr)
  }

  function changeText(e, rowID, inputType, IDvalue = 0, desc = null) {
    let target = e?.target ? e.target : '';
    let value = target !== '' ? target.value : '';
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const AccountTypeName = newArr[idx].accountTypeName;
    for (let i = 0; i < newArr.length; i++) {
      if (i !== idx && newArr[i].accountTypeName === AccountTypeName) {
        if (inputType === 'credit' && parseInt(newArr[i].debit) !== 0) {
          alert.error('No Credit amounts are allowed for this Account.');
          return;
        }
        else if (inputType === 'debit' && parseInt(newArr[i].credit) !== 0) {
          alert.error('No Debit amounts are allowed for this Account.');
          return;
        }
      }
    }
    if (inputType === "description") {
      newArr[idx] = { ...newArr[idx], description: value };
    }
    else if (inputType.includes('descriptionType')) {
      newArr[idx] = { ...newArr[idx], descriptionType: desc, descriptionTypeID: IDvalue };
    }
    else if (inputType === "childHeader") {
      newArr[idx] = { ...newArr[idx], childHeaderID: IDvalue, childHeaderName: desc };
    }
    else if (inputType === 'credit') {
      var reg = new RegExp('^[.0-9]*$');
      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }
      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = true;
        creditBool = false;
      }
      if (value.toString().length > 18) {
        alert.error('Allow Only 18 Numbers');
        return;
      }
      newArr[idx] = {
        ...newArr[idx],
        credit: value === '' ? 0 : value,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    } else {
      var reg = new RegExp('^[.0-9]*$');

      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }
      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = false;
        creditBool = true;
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = {
        ...newArr[idx],
        debit: IDvalue === '' ? 0 : IDvalue,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    }
    setJournalData(newArr);
  }

  function GenerateRandomID() {
    const d = new Date();
    let ms = d.valueOf();

    let rendomValue =
      ms + Math.floor(Math.random() * 10000) - 12 + (ms - 128 + ms * 512);
    return rendomValue;
  }

  function onKeyDown(e, id, data) {
    if (e.key === "Tab") {
      if (data.credit != 0 || data.debit != 0) {
        if (journalData[journalData.length - 1].rowID.toString() === id.toString() && !isUpdate) {
          let ID = GenerateRandomID()
          journalData.push({ accountTypeName: 0, childHeaderID: 0, credit: 0, debit: 0, ledgerTransactionID: 0, rowID: ID, selected: [] })
          var result = refNo == undefined ? 0 : refNo.substring(0, 3);
          setJournalData(journalData)
          if (result == 'CHP') {
            getChequeNumber(data)
          }
        }
      }
      else {
        alert.error("please enter amount");
      }
    }
  };

  async function getChequeNumber(data) {
    let response = await services.getChequeNumber(data.accountTypeName);
    if (response.data == null) {
      alert.error(response.message);
    } else {
      setGeneralJournal({
        ...generalJournal,
        chequeNumber: response.data
      });
    }
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: generalJournal.groupID,
              factoryID: generalJournal.factoryID,
              referenceNumber: referenceNumber,
              recipientName: generalJournal.recipientName,
              description: generalJournal.description,
              descriptionTypeID: generalJournal.descriptionTypeID,
              voucherType: generalJournal.voucherType,
              transactionMode: generalJournal.transactionMode,
              chequeNumber: generalJournal.chequeNumber,
              isActive: generalJournal.isActive,
              isInterEstate: generalJournal.isInterEstate,
              interEstateID: generalJournal.interEstateID,
              tranLedgerAccountID: generalJournal.tranLedgerAccountID,
              supplierID: generalJournal.supplierID,
              modeoftransaction: generalJournal.modeoftransaction,
              modeoftransactionNumber: generalJournal.modeoftransactionNumber,
              payee: generalJournal.payee,
              supplierCommon: supplierCommon
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group required').min('1', 'Group required'),
              factoryID: Yup.number().required('Factory required').min('1', 'Factory required'),
              referenceNumber: Yup.string().required('Reference number required'),
              // voucherType: Yup.number()
              //   .required('Voucher Type required')
              //   .min('1', 'Voucher Type required'),
              // transactionMode: Yup.number()
              //   .required('Transaction Mode required')
              //   .min('1', 'Transaction Mode required'),
              // chequeNumber: Yup.string().when('payModeID', {
              //   is: val => val == '2',
              //   then: Yup.string().required('Cheque number required')
              // }),
              // interEstateID: Yup.number().when('isInterEstate', {
              //   is: true,
              //   then: Yup.number()
              //     .required('Inter Estate required')
              //     .min(1, 'Inter Estate required'),
              // }),
              tranLedgerAccountID: Yup.number().required('Ledger Account is required').min('1', 'Ledger Account is required'),
              modeoftransaction: Yup.number().required('Mode of transaction required').min("1", 'Select Mode of transaction'),
              // modeoftransactionNumber: Yup.string().when('modeoftransaction', {
              //   is: (modeoftransaction) => modeoftransaction !== 3 && !isUpdate ,
              //   then: Yup.string().required('Number is required').matches(/^\d+$/, 'Enter valid Number.').nullable()
              // }),
              supplierID: Yup.number()
                .required('Supplier required')
                .min('1', 'Supplier required'),
              supplierCommon: Yup.bool(),
              payee: Yup.string().when('supplierCommon', {
                is: (supplierCommon) => supplierCommon == true && !isUpdate,
                then: Yup.string()
                  .required('Payee required'),
                otherwise: Yup.string().nullable(),
              }),
            })}
            onSubmit={event => trackPromise(SaveGeneralJournal(event))}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={isInterStatus || isUpdate}
                              InputProps={{
                                readOnly:
                                  isUpdate ||
                                    !permissionList.isGroupFilterEnabled
                                    ? true
                                    : false
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={generalJournal.factoryID}
                              disabled={isInterStatus || isUpdate}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly:
                                  isUpdate ||
                                    !permissionList.isFactoryFilterEnabled
                                    ? true
                                    : false
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel
                              shrink
                              id="date"
                              style={{ marginBottom: '-8px' }}
                            >
                              Date *
                            </InputLabel>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedDate}
                                minDate={financialYearStartDate}
                                maxDate={maxDate}
                                disabled={dateDisable || isInterStatus || isUpdate}
                                onChange={e => {
                                  handleDateChange(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          {Hidden == true ? (
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="voucherType">
                                Voucher Type *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.voucherType && errors.voucherType
                                )}
                                fullWidth
                                helperText={
                                  touched.voucherType && errors.voucherType
                                }
                                name="voucherType"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournal.voucherType}
                                variant="outlined"
                                id="voucherType"
                                disabled={isInterStatus || isUpdate}
                                InputProps={{
                                  readOnly: isUpdate ? true : false
                                }}
                              >
                                <MenuItem value="0">
                                  --Select Voucher Type--
                                </MenuItem>
                                {generateDropownForVoucherList(voucherTypes)}
                              </TextField>
                            </Grid>
                          ) : null}
                          {isUpdate ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="tranLedgerAccountID">
                                Bank Account *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.tranLedgerAccountID &&
                                  errors.tranLedgerAccountID
                                )}
                                fullWidth
                                helperText={
                                  touched.tranLedgerAccountID &&
                                  errors.tranLedgerAccountID
                                }
                                name="tranLedgerAccountID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => {
                                  handleChangeForm(e);
                                }}
                                value={generalJournal.tranLedgerAccountID}
                                variant="outlined"
                                id="tranLedgerAccountID"
                                disabled={isInterStatus || isUpdate}
                                InputProps={{
                                  readOnly: isUpdate ? true : false
                                }}
                              >
                                <MenuItem value="0">
                                  --Select Ledger Account--
                                </MenuItem>
                                {generateDropDownMenu(
                                  tranLedgerList
                                )}
                              </TextField>
                            </Grid>
                            :
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="tranLedgerAccountID">
                                Bank Account *
                              </InputLabel>
                              <Autocomplete
                                id="tranLedgerAccountID"
                                options={tranLedgerListAuto}
                                getOptionLabel={(option) => option.ledgerAccountName != null ? option.ledgerAccountName.toString() : null}
                                onChange={(e, value) => handleSearchDropdownChangeFields(value, e)}
                                defaultValue={null}
                                renderInput={(params) =>
                                  <TextField {...params}
                                    variant="outlined"
                                    name="tranLedgerAccountID"
                                    fullWidth
                                    size='small'
                                    placeholder='--Select Ledger Account--'
                                    value={generalJournal.tranLedgerAccountID}
                                    getOptionDisabled={true}
                                    helperText={touched.tranLedgerAccountID && errors.tranLedgerAccountID}
                                    onBlur={handleBlur}
                                    error={Boolean(touched.tranLedgerAccountID && errors.tranLedgerAccountID)}
                                  >
                                    <MenuItem value={'0'} >--Select Ledger Account--</MenuItem>
                                  </TextField>
                                }
                              />
                            </Grid>}
                          {isUpdate ? <Grid item md={4} xs={12}>
                            <InputLabel shrink id="referenceNumber">
                              Voucher Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(
                                touched.referenceNumber &&
                                errors.referenceNumber
                              )}
                              fullWidth
                              helperText={
                                touched.referenceNumber &&
                                errors.referenceNumber
                              }
                              name="referenceNumber"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={refNo}
                              variant="outlined"
                              InputProps={{
                                readOnly: true
                              }}
                              disabled={isInterStatus || isUpdate}
                            />
                          </Grid> : null}
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="modeoftransaction">
                              Mode of transaction *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.modeoftransaction && errors.modeoftransaction)}
                              fullWidth
                              helperText={touched.modeoftransaction && errors.modeoftransaction}
                              name="modeoftransaction"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => { handleChangeForm(e); }}
                              value={generalJournal.modeoftransaction}
                              variant="outlined"
                              id="modeoftransaction"
                              disabled={isInterStatus || isUpdate}
                              InputProps={{
                                readOnly: isUpdate ? true : false
                              }}
                            >
                              <MenuItem value="0">--Select Transaction Mode--</MenuItem>
                              <MenuItem value="3"> Cheque </MenuItem>
                              <MenuItem value="7"> Fund Transfer </MenuItem>
                              {/* <MenuItem value="1">Main Cash</MenuItem>
                              <MenuItem value="2">General Cash</MenuItem>
                              <MenuItem value="3">Cheque</MenuItem>
                              <MenuItem value="4">Income Invoice</MenuItem>
                              <MenuItem value="5">Supplier Invoice</MenuItem>
                              <MenuItem value="6">Provision</MenuItem>
                              <MenuItem value="7">Transfer</MenuItem> */}
                            </TextField>
                          </Grid>
                          {generalJournal.modeoftransaction > 0 && generalJournal.modeoftransaction != 3 ?
                            <Grid item md={4} xs={12}>
                              {generalJournal.modeoftransaction == 1 ?
                                <InputLabel shrink id="modeoftransactionNumber">
                                  Cheque Number *
                                </InputLabel>
                                :
                                <InputLabel shrink id="modeoftransactionNumber">
                                  Fund Transfer Number
                                </InputLabel>}
                              {generalJournal.modeoftransaction == 1 ?
                                <TextField
                                  error={Boolean(touched.modeoftransactionNumber && errors.modeoftransactionNumber || Boolean(ChequeNumberError))}
                                  fullWidth
                                  helperText={touched.modeoftransactionNumber && errors.modeoftransactionNumber ? errors.modeoftransactionNumber : ChequeNumberError}
                                  name="modeoftransactionNumber"
                                  size="small"
                                  onBlur={handleBlur}
                                  onChange={e => {
                                    handleChangeForm(e);
                                    handleChangeForChequeNumber(e);
                                  }}
                                  inputProps={{
                                    maxLength: 6,
                                  }}
                                  value={generalJournal.modeoftransactionNumber}
                                  disabled={isUpdate}
                                  variant="outlined"
                                /> : <TextField
                                  error={Boolean(touched.modeoftransactionNumber && errors.modeoftransactionNumber)}
                                  fullWidth
                                  helperText={touched.modeoftransactionNumber && errors.modeoftransactionNumber}
                                  name="modeoftransactionNumber"
                                  size="small"
                                  onBlur={handleBlur}
                                  onChange={e => {
                                    handleChangeForm(e);
                                    handleChangeForChequeNumber(e);
                                  }}
                                  value={generalJournal.modeoftransactionNumber}
                                  disabled={isUpdate}
                                  variant="outlined"
                                />}
                            </Grid> : null}
                          {isUpdate ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="supplierID">
                                Supplier *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.supplierID && errors.supplierID
                                )}
                                fullWidth
                                helperText={touched.supplierID && errors.supplierID}
                                name="supplierID"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeSupplier(e)}
                                value={generalJournal.supplierID}
                                disabled={isUpdate}
                                variant="outlined"
                                id="supplierID"
                              >
                                <MenuItem value="0">--Select Supplier--</MenuItem>
                                {generateDropDownMenuWithTwoValues(suppliers)}
                              </TextField>
                            </Grid>
                            :
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="supplierID">
                                Supplier *
                              </InputLabel>
                              <Autocomplete
                                id="supplierID"
                                options={suppliersAuto}
                                getOptionLabel={(option) => option.supplierName != null ? option.supplierName.toString() : null}
                                onChange={(e, value) => handleSearchDropdownChangeFieldsSupplier(value, e)}
                                defaultValue={null}
                                renderInput={(params) =>
                                  <TextField {...params}
                                    variant="outlined"
                                    name="supplierID"
                                    fullWidth
                                    size='small'
                                    placeholder='--Select Supplier--'
                                    value={generalJournal.supplierID}
                                    getOptionDisabled={true}
                                    helperText={touched.supplierID && errors.supplierID}
                                    onBlur={handleBlur}
                                    error={Boolean(touched.supplierID && errors.supplierID)}
                                  >
                                    <MenuItem value={'0'} >--Select Supplier--</MenuItem>
                                  </TextField>
                                }
                              />
                            </Grid>}
                          {supplierCommon ?
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="payee">
                                Payee *
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.payee && errors.payee
                                )}
                                fullWidth
                                helperText={
                                  touched.payee && errors.payee
                                }
                                name="payee"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournal.payee}
                                variant="outlined"
                                disabled={isDisableButton || isUpdate}
                                id="payee"
                              />
                            </Grid>
                            : null}
                          {transactionModeCode == 'CH' ? (
                            <Grid item md={4} xs={12}>
                              <InputLabel
                                shrink
                                id="chequeNumber"
                                style={{ marginBottom: '-8px' }}
                              >
                                Due Date
                              </InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  fullWidth
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  margin="dense"
                                  id="date-picker-inline"
                                  value={selectedDueDate}
                                  disabled={isInterStatus}
                                  onChange={e => {
                                    handleDueDateChange(e);
                                  }}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                  autoOk
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          ) : null}
                        </Grid>
                        {transactionModeCode == 'CH' ? (
                          <Grid container spacing={3}>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="chequeNumber">
                                Cheque Number
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.chequeNumber && errors.chequeNumber
                                )}
                                fullWidth
                                helperText={
                                  touched.chequeNumber && errors.chequeNumber
                                }
                                name="chequeNumber"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournal.chequeNumber}
                                variant="outlined"
                                disabled={isDisableButton}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="recipientName">
                                Recipient Name
                              </InputLabel>
                              <TextField
                                error={Boolean(
                                  touched.recipientName && errors.recipientName
                                )}
                                fullWidth
                                helperText={
                                  touched.recipientName && errors.recipientName
                                }
                                name="recipientName"
                                size="small"
                                onBlur={handleBlur}
                                onChange={e => handleChangeForm(e)}
                                value={generalJournal.recipientName}
                                variant="outlined"
                                disabled={isDisableButton}
                              />
                            </Grid>
                          </Grid>
                        ) : null}
                      </CardContent>
                      <CardContent height="auto">
                        <Box style={{ border: '1px solid gray' }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Child Header *</TableCell>
                                <TableCell>Account Name *</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Description Category</TableCell>
                                <TableCell>Amount *</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {journalData.map((object, index) => {
                                let ID = object.rowID;
                                return (
                                  <TableRow>
                                    {isUpdate ?
                                      <TableCell style={{ padding: "5px", width: "15rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size={"small"}
                                          style={{ width: "15rem" }}
                                          name={ID}
                                          onBlur={handleBlur}
                                          onChange={(e) => changeText(e, ID, "childHeader")}
                                          disabled={true}
                                          value={object.childHeaderName}
                                          fullWidth />
                                      </TableCell>
                                      : <TableCell style={{ padding: "5px", width: "15rem" }}>
                                        <Autocomplete
                                          id={ID.toString()}
                                          options={childHeaderNames}
                                          size={"small"}
                                          style={{ width: "15rem" }}
                                          getOptionLabel={(option) => option.childHeaderName}
                                          onChange={(e, value) => handleSearchDropdownChangeForChildHeaders("childHeader", value, ID)}
                                          value={object.selectedChildHeader !== undefined ? object.selectedChildHeader[0] : null}
                                          disabled={isUpdate || isInterStatus}
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth autoFocus variant="outlined" placeholder="--Select Child Header--" />
                                          )}
                                        />
                                      </TableCell>
                                    }
                                    {isUpdate ?
                                      <TableCell style={{ padding: "5px", width: "15rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size={"small"}
                                          style={{ width: "15rem" }}
                                          name={ID}
                                          onBlur={handleBlur}
                                          onChange={(e) => changeText(e, ID, "ledgerAccountName")}
                                          disabled={true}
                                          value={object.ledgerAccountName}
                                          fullWidth />
                                      </TableCell>
                                      : <TableCell style={{ padding: "5px", width: "15rem" }}>
                                        <Autocomplete
                                          id={ID.toString()}
                                          options={accountTypeNames}
                                          size={"small"}
                                          style={{ width: "15rem" }}
                                          getOptionLabel={(option) => option.ledgerAccountName}
                                          onChange={(e, value) => handleSearchDropdownChange("accountName", value, ID)}
                                          value={object.selected !== undefined ? object.selected[0] : null}
                                          disabled={isUpdate || isInterStatus}
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth autoFocus variant="outlined" placeholder="--Select Account--" />
                                          )}
                                        />
                                      </TableCell>
                                    }
                                    <TableCell style={{ padding: "16px", width: "25%" }}>
                                      <TextField
                                        variant="outlined"
                                        size={"small"}
                                        placeholder="--Enter Description--"
                                        name={ID}
                                        onBlur={handleBlur}
                                        onChange={(e) => changeText(e, ID, "description")}
                                        value={object.description}
                                        fullWidth />
                                    </TableCell>
                                    <TableCell style={{ padding: "16px", width: "25%" }}>
                                      {isUpdate ?
                                        <TextField select
                                          fullWidth
                                          name="descriptionType"
                                          size='small'
                                          onBlur={handleBlur}
                                          onChange={e => handleChangeForm(e)}
                                          disabled={isUpdate}
                                          value={object.descriptionTypeID}
                                          variant="outlined"
                                          id="descriptionTypeID"
                                        >
                                          <MenuItem value="0">--Select Description Type--</MenuItem>
                                          {generateDropDownMenu(accountDescriptionsTypeAll)}
                                        </TextField>
                                        :
                                        <Autocomplete
                                          id={ID.toString()}
                                          key={object.descriptionTypeID}
                                          options={accountDescriptions?.[ID] ?? []}
                                          size="small"
                                          disabled={!(accountDescriptions?.[ID] && accountDescriptions[ID].length > 0)}
                                          freeSolo={!accountDescriptions?.[ID]}
                                          getOptionLabel={option =>
                                            typeof option === 'string' ? option : option.accountDescription
                                          }
                                          onChange={(e, value) => {
                                            if (value && value.accountDescriptionTypeID !== undefined) {
                                              changeText(e, ID, 'descriptionType', value.accountDescriptionTypeID, value.accountDescription);
                                            }
                                          }}
                                          clearOnBlur
                                          disableClearable={!accountDescriptions?.[ID]}
                                          value={
                                            accountDescriptions?.[ID]?.find(
                                              (desc) => desc.accountDescriptionTypeID === object.descriptionTypeID) || null
                                          }
                                          renderInput={params => (
                                            <TextField {...params} fullWidth autoFocus variant="outlined" placeholder="--Select Description Type--" />
                                          )}
                                        />}
                                    </TableCell>
                                    <TableCell style={{ verticalAlign: "top", width: '25%' }}>
                                      <TextField
                                        variant="outlined"
                                        size={'small'}
                                        name={ID}
                                        onBlur={handleBlur}
                                        fullWidth
                                        onChange={e =>
                                          changeText(e, ID, 'debit', e.target.value)
                                        }
                                        value={object.debit}
                                        onKeyDown={(e) => onKeyDown(e, ID, object)}
                                        inputProps={{
                                          readOnly: object.disableDebitField
                                        }}
                                        disabled={isInterStatus}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </Box>
                      </CardContent>
                      <CardContent>
                        <Box border={1} borderColor="#626964" >
                          <Table style={{ border: 'none', width: '100%' }}>
                            <TableBody>
                              <TableRow style={{ border: 'none' }}>
                                <TableCell style={{ borderBottom: 'none', width: '75%' }}>
                                  <InputLabel>
                                    <b>Prepared By </b>
                                    {isUpdate ? " : " + generalJournal.preparedBy : ": " + findLoginUser()}
                                  </InputLabel>
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none', width: '25%' }}>
                                  <InputLabel>
                                    <b><CountUp style={{ marginLeft: '13%' }} decimals={2} separator=',' end={calDebitTotal()} duration={0.1} /></b>
                                  </InputLabel>
                                </TableCell>
                              </TableRow>
                              {isUpdate ?
                                <TableRow style={{ border: 'none' }}>
                                  <TableCell style={{ borderBottom: 'none', width: '75%' }}>
                                    <InputLabel ><b>Updated By</b>{" : " + findLoginUser()}</InputLabel>
                                  </TableCell>
                                </TableRow>
                                : null}
                            </TableBody>
                          </Table>
                        </Box>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnCancel"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorCancel}
                          disabled={isInterStatus}
                          onClick={() => Cancel()}
                        >
                          Cancel
                        </Button>
                        {!isUpdate ? (
                          <Button
                            color="primary"
                            id="btnRecordAndNew"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecordAndNew}
                            onClick={RecordAndNew}
                          >
                            Record and New
                          </Button>) : null}
                        {permissionList.isApproveButtonEnabled == true && !isUpdate ?
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={ApproveClick}
                          >
                            Approve
                          </Button>
                          : null}
                        {isUpdate && status != 2 ? (
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            disabled={isInterStatus}
                          >
                            Update
                          </Button>
                        ) : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
